import React, { useState, useEffect, useRef } from "react";
import { Outlet } from "react-router-dom";
import { Row, Col } from "../ui/ot";
import { useWebsiteBasicInformation } from "../official_web/controller/WebsiteBasicInformationController";
import axios from "axios";
import FooterComponent from "./footer/footer"
import HeaderComponent from "./header/header"
import Navigation from "./navigation/navigation"
import Container from "./container/container"


const ComponentLayout = ({
    menuData = [
        {
            label: "國科會相關計畫",
            key: "/officialweb/frontend/442",
            type: "primary",
            path_check: 0,
            children: [
                {
                    label: "aaaaaaaaaa",
                    key: "/officialweb/frontend/295/443",
                    path_check: 0,
                    children: [
                        {
                            label: "wweedxweddc",
                            key: "/officialweb/frontend/295/443/446",
                            path_check: 0,
                            children: [
                                {
                                    label: "asdfghjkjhbvcxz",
                                    key: "/officialweb/frontend/295/443/446/447",
                                    path_check: 0,
                                    children: [],
                                },
                            ],
                        },
                    ],
                },
                {
                    label: "tgbhnjkloiuyhg",
                    key: "/officialweb/frontend/295/444",
                    path_check: 0,
                    children: [
                        {
                            label: "qwertyuiolkmnbvcx",
                            key: "/officialweb/frontend/295/444/445",
                            path_check: 0,
                            children: [],
                        },
                    ],
                },
            ],
        },
        {
            label: "本計畫各類好聞",
            key: "/officialweb/frontend/442",
            type: "primary",
            path_check: 1,
            children: [],
        },
        {
            label: "國際資訊",
            type: "primary",
            key: "/officialweb/frontend/442",
            path_check: 0,
            children: [],
        },
        {
            label: "統計資料庫",
            key: "/officialweb/frontend/449",
            type: "primary",
            path_check: 0,
            children: [],
        },
        {
            label: "會議.活動.連結",
            key: "/officialweb/frontend/449",
            type: "primary",
            path_check: 0,
            children: [],
        },
        {
            label: "關於我們",
            key: "/officialweb/frontend/449",
            type: "secondary",
            path_check: 0,
            children: [],
        },
        {
            label: "著作權聲明",
            key: "/officialweb/frontend/449",
            type: "secondary",
            path_check: 0,
            children: [],
        },
    ],
    defaultWebsiteBasicInformationData = [
        {
            information_id: 2,
            name: "primary",
            phone: "07-7172930",
            address: "802高雄市苓雅區和平一路116號",
            email: "tf@mail.nknu.edu.tw",
            contact_person: "cdcdc",
            google_map_iframe: ``,
            view_count: 410,
            information_community_data: [
            ],
            name_language_data: [
                {
                    language_manage_id: 1269,
                    language_culture_code: "zh-tw",
                    language_culture_name: "繁體中文",
                    language_culture_value: "Copyright © 2021 國科會補助「性別化創新的應用與推廣」",
                },
                {
                    language_manage_id: 1270,
                    language_culture_code: "en",
                    language_culture_name: "英語",
                    language_culture_value: "Gender in Science & Technology. All Rights Reserved",
                },
            ],
            classify_structure_type_information_data: [
            ],
            classify_structure_type_data: [
                {
                    classify_structure_type_id: 4095,
                    value: 4095,
                    classify_structure_type_parent_id: 0,
                    classify_structure_id: 3,
                    name: "頁尾Logo",
                    title: "頁尾Logo",
                    index: 1,
                    background_color: null,
                    font_color: null,
                    blog_data: [
                        {
                            blog_id: null,
                            title: null,
                            content: null,
                            blog_type_id: null,
                            annoucement_time: null,
                            top: null,
                            blog_index: null,
                            more_content: null,
                            background_color: null,
                            font_color: null,
                            pic_background_color: null,
                        },
                    ],
                    children: [],
                    classify_structure_type_file_data: [
                        {
                            classify_structure_type_file_id: 48112,
                            file_id: 4391,
                            file_url:
                                "blob:http://localhost:3000/b0f605b1-2fb6-4c13-861a-2e7f1f2b798f",
                        },
                    ],
                    key: 1,
                    depth: 1,
                },
                {
                    classify_structure_type_id: 4096,
                    value: 4096,
                    classify_structure_type_parent_id: 0,
                    classify_structure_id: 3,
                    name: "Logo",
                    title: "Logo",
                    index: 1,
                    background_color: null,
                    font_color: null,
                    blog_data: [
                        {
                            blog_id: null,
                            title: null,
                            content: null,
                            blog_type_id: null,
                            annoucement_time: null,
                            top: null,
                            blog_index: null,
                            more_content: null,
                            background_color: null,
                            font_color: null,
                            pic_background_color: null,
                        },
                    ],
                    children: [],
                    classify_structure_type_file_data: [
                        {
                            classify_structure_type_file_id: 48113,
                            file_id: 4388,
                            file_url:
                                "https://taiwan-gist.nknu.edu.tw/images/logo113003.png",
                        },
                    ],
                    key: 2,
                },
                {
                    classify_structure_type_id: 4097,
                    value: 4097,
                    classify_structure_type_parent_id: 0,
                    classify_structure_id: 3,
                    name: "頁底圖片",
                    title: "頁底圖片",
                    index: 1,
                    background_color: null,
                    font_color: null,
                    blog_data: [
                        {
                            blog_id: null,
                            title: null,
                            content: null,
                            blog_type_id: null,
                            annoucement_time: null,
                            top: null,
                            blog_index: null,
                            more_content: null,
                            background_color: null,
                            font_color: null,
                            pic_background_color: null,
                        },
                    ],
                    children: [],
                    classify_structure_type_file_data: [
                        {
                            classify_structure_type_file_id: 48114,
                            file_id: 4390,
                            file_url:
                                "https://taiwan-gist.nknu.edu.tw/images/logo113003.png",
                        },
                    ],
                    key: 3,
                    depth: 1,
                },
            ],
            key: 1,
            information_staff_data: [],
        },
    ],
}) => {

    const [information, setInformation] = useState(null);
    const [imageFile, setImageFile] = useState([]);
    const firstRender = useRef(true);

    const get_picture = (temp) => {
        (temp || []).forEach((element) => {
            const fileDataArray = element.classify_structure_type_file_data || [];
            fileDataArray.forEach((fileData) => {
                if (fileData?.file_id) {
                    axios
                        .get("/media/api/file/upload", {
                            responseType: "blob",
                            params: {
                                file_id: fileData?.file_id,
                            },
                        })
                        .then((response) => {
                            var blob_ = new Blob([response.data], {
                                type: "image/jpg", // 如果是 SVG, 這裡可以改成 image/svg+xml
                            });
                            const dataurl = URL.createObjectURL(blob_);

                            setImageFile((pre) => {
                                return pre.map((element) => {
                                    if (element.classify_structure_type_file_data) {
                                        element.classify_structure_type_file_data = element.classify_structure_type_file_data.map((file) => {
                                            if (parseInt(fileData?.file_id) === parseInt(file?.file_id)) {
                                                return {
                                                    ...file,
                                                    file_url: dataurl,
                                                };
                                            } else {
                                                return file;
                                            }
                                        });
                                    }
                                    return element;
                                });
                            });
                        })
                        .catch((error) => {
                            console.error(`Error fetching image for file_id ${fileData?.file_id}:`, error);
                        });
                }
            });
        });
    };

    const {
        WebsiteBasicInformationData,
        getWebsiteBasicInformationData,
        patchWebsiteBasicInformationClickData,
    } = useWebsiteBasicInformation({});

    useEffect(() => {
        let WebsiteBasicInformationDataFirst = WebsiteBasicInformationData?.find(_ => true);
        let classifyStructureTypeData = WebsiteBasicInformationDataFirst?.classify_structure_type_data || [];
        setImageFile(classifyStructureTypeData);
        setInformation(WebsiteBasicInformationDataFirst);
    }, [WebsiteBasicInformationData]);

    useEffect(() => {
        getWebsiteBasicInformationData();
        patchWebsiteBasicInformationClickData();
    }, []);

    useEffect(() => {
        if (firstRender.current && imageFile.length > 0) {
            get_picture(imageFile);
            firstRender.current = false;
        }
    }, [imageFile]);

    return (
        <>
            <div className="flex flex-col min-h-screen">
                <HeaderComponent information={information} imageFileData={imageFile}>
                </HeaderComponent>
                <Navigation menuData={menuData} />
                <Container>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Outlet />
                        </Col>
                    </Row>
                </Container>
                <FooterComponent information={information} imageFileData={imageFile} />
            </div>
        </>
    );
};

export default ComponentLayout;
